import PrimeDatalayerTracking from "./PrimeDatalayerTracking";

export { default as PrimeDatalayerTrackingTripDetails } from "./PrimeDatalayerTrackingTripDetails";
export default PrimeDatalayerTracking;
